import React from 'react';
// import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
//import 'react-tabs/style/react-tabs.css';
import Dropdown from 'react-dropdown';
import copy from 'copy-to-clipboard';
import toast from '../../components/Toastify';
import { UpgradePlanCard } from '../../components';

const cmpOption = [
  { value: 'product', label: 'Product' },
  { value: 'localbusiness', label: 'Local Business' },
  { value: 'softwereAppllication', label: 'SoftwereAppllication' },
  { value: 'course', label: 'Course' },
  { value: 'organization', label: 'Organization' }
];

const softOption = [
  { value: 'gameApplication', label: 'GameApplication' },
  { value: 'socialNetworkingApplication', label: 'SocialNetworkingApplication' },
  { value: 'travelApplication', label: 'TravelApplication' },
  { value: 'shoppingApplication', label: 'ShoppingApplication' },
  { value: 'sportsApplication', label: 'SportsApplication' },
  { value: 'lifestyleApplication', label: 'LifestyleApplication' },
  { value: 'businessApplication', label: 'BusinessApplication' },
  { value: 'designApplication', label: 'DesignApplication' },
  { value: 'developerApplication', label: 'DeveloperApplication' },
  { value: 'driverApplication', label: 'DriverApplication' },
  { value: 'educationalApplication', label: 'EducationalApplication' },
  { value: 'healthApplication', label: 'HealthApplication' },
  { value: 'financeApplication', label: 'FinanceApplication' },
  { value: 'securityApplication', label: 'SecurityApplication' },
  { value: 'browserApplication', label: 'BrowserApplication' },
  { value: 'communicationApplication', label: 'CommunicationApplication' },
  { value: 'desktopEnhancementApplication', label: 'DesktopEnhancementApplication' },
  { value: 'entertainmentApplication', label: 'EntertainmentApplication' },
  { value: 'multimediaApplication', label: 'MultimediaApplication' },
  { value: 'homeApplication', label: 'HomeApplication' },
  { value: 'utilitiesApplication', label: 'UtilitiesApplication' },
  { value: 'referenceApplication', label: 'ReferenceApplication' }
];

const SchemaCard = ({
  state,
  widgetById,
  // handleWidgetChange,
  handleSchemaChange,
  handleSchemaStore,
  handleUpgradePlan
}) => {
  //get total count and avrage rating
  let widgetValue = 0;
  let widgetReview = 0;
  if (widgetById && widgetById.dsi && widgetById.dsi.length > 0) {
    for (let i = 0; i < widgetById.dsi.length; i++) {
      widgetValue += widgetById.dsi[i].pgrtngavg;
      widgetReview += widgetById.dsi[i].pgrtngcnt ? widgetById.dsi[i].pgrtngcnt : 0;
    }

    let dsiCount = 0;
    for (let i = 0; i < widgetById.dsi.length; i++) {
      const d = widgetById.dsi[i];
      if (d.pgrtngavg > 0) {
        dsiCount += 1;
      }
    }
    widgetValue = widgetValue ? (widgetValue / dsiCount).toFixed(1) : 5;
  }

  const copyWidgetDiv = () => {
    let schemaCode;
    let _type = widgetById.scmcmpnm ? widgetById.scmcmpnm : '';
    let _name = widgetById.scmathr ? widgetById.scmathr : '';
    let _applicationCategory = widgetById.scmctgry ? widgetById.scmctgry : '';
    let _description = widgetById.scmdsc ? widgetById.scmdsc : '';
    let _image = widgetById.scmimgurl ? widgetById.scmimgurl : '';


    if (widgetById.scmcmpnm == 'softwereAppllication') {
      schemaCode =
        `<script type="application/ld+json">
        {
         "@context": "https://schema.org/",
         "@type": "`+ _type + `",
         "name": "`+ _name + `",
         "applicationCategory": "`+ _applicationCategory + `",
         "description": "`+ _description + `",
         "image": "`+ _image + `",
         "aggregateRating":{
          "@type": "AggregateRating",
          "ratingValue": "`+ widgetValue + `",
          "ratingCount": "`+ widgetReview + `"
         }
        }
      </script>`;
    }
    else {
      schemaCode =
        `<script type="application/ld+json">
        {
         "@context": "https://schema.org/",
         "@type": "`+ _type + `",
         "name": "`+ _name + `",
         "description": "`+ _description + `",
         "image": "`+ _image + `",
         "aggregateRating":{
          "@type": "AggregateRating",
          "ratingValue": "`+ widgetValue + `",
          "ratingCount": "`+ widgetReview + `"
         }
        }
      </script>`;
    }
    copy(schemaCode, { debug: true });
    if (!toast.isActive(this.toastId)) {
      this.toastId = toast.success('Your Schema code is copied.');
    }
  };

  return (
    <div className='card card-editor card-header card-editor-seo'>
      <div className='card-editor-block p-0'>
        <div className='card-plan-div'>
          <label className="card-editor-title">Schema</label>
          <UpgradePlanCard
            handleUpgradePlan={handleUpgradePlan}
          />
        </div>
        <div className=''>

          <div className="editor-input header-editor-ckeditor editor-header-title">
            <label className="label-title">Property type</label>
            <Dropdown className="nf-select-dropdown nf-select-defaultsm"
              options={cmpOption}
              value={state._scmcmpnm != undefined ? state._scmcmpnm.toString() : state._scmcmpnm}
              onChange={(e) => handleSchemaChange('scmcmpnm', e.value)} />
          </div>

          {state._scmcmpnm === 'softwereAppllication' &&
            <div className="editor-input header-editor-ckeditor editor-header-title">
              <label className="label-title">Application Category</label>
              <Dropdown
                className="nf-select-dropdown nf-select-defaultsm"
                options={softOption} value={state._scmctgry != undefined ? state._scmctgry.toString() : state._scmctgry}
                onChange={(e) => handleSchemaChange('scmctgry', e.value)} />
            </div>
          }

          <div className="editor-input header-editor-ckeditor editor-header-title">
            <label className="label-title"> Name</label>
            <input className="editor-input-content editor-input-fullwidth editor-input-inckey"
              type="text" placeholder="Enter Name"
              value={state._scmathr}
              onChange={(e) => handleSchemaChange('scmathr', e.target.value)} />
          </div>

          <div className="editor-input header-editor-ckeditor editor-header-title">
            <label className="label-title">Description</label>
            <textarea
              className="editor-input-content editor-input-fullwidth schema-DEsc"
              cols="2"
              rows="2"
              placeholder='Description'
              value={state._scmdsc}
              onChange={(e) => handleSchemaChange('scmdsc', e.target.value)} >
            </textarea>
          </div>

          <div className="editor-input header-editor-ckeditor editor-header-title">
            <label className="label-title">Logo Image URL</label>
            <input className="editor-input-content editor-input-fullwidth editor-input-inckey"
              type="text" placeholder="Image URL"
              value={state._scmimgurl}
              onChange={(e) => handleSchemaChange('scmimgurl', e.target.value)} />
          </div>

          <div className="edit-review-adddownload schema-code-btn">
            <button onClick={() => handleSchemaStore()} type="button" className="nf-btn nf-btn-default nf-btn-noneBdr nf-bt-updsav">Generate Schema Code</button>
          </div>
          <div className='edit-copycode-head'>
            <label className='copycode-schema-label'>
              Paste this code in your website {'<'}head{'>'} section
            </label>
            <div className='copycode-schema-btn' onClick={(e) => copyWidgetDiv(e)}>
              Copy
            </div>
          </div>
          <div className="CodeMirror-code" >
            <pre _ngcontent-isv-c7="" className=" full-width ng-star-inserted language-json" onClick={(e) => copyWidgetDiv(e)}>
              <code _ngcontent-isv-c7="" className="language-json" id="widgetEmbedGlobal">
                <span className='line'>
                  <span className="token punctuation">{'<'}</span>
                  <span className="token property">script</span>
                  <span className="property"> type="application/ld+json"</span>
                  <span className="token punctuation">{'>'}</span>
                </span>
                <span className='line' style={{ display: 'flex' }}>
                  <span className="token punctuation">{'{'}</span>
                </span>
                <div className='line'>
                  <span className="cl"> <span className="token property">"@context"</span><span className="token operator">:</span> <span className="token string">"https://schema.org/"</span><span className="token punctuation">,</span></span>
                </div>
                <div className='line'>
                  <span className="cl"> <span className="token property">"@type"</span><span className="token operator">:</span> <span className="token string">"{widgetById.scmcmpnm}"</span><span className="token punctuation">,</span></span>
                </div>
                <div className='line'>
                  <span className="cl"> <span className="token property">"name"</span><span className="token operator">:</span> <span className="token string">"{widgetById.scmathr}"</span><span className="token punctuation">,</span></span>
                </div>
                {
                  widgetById.scmcmpnm == 'softwereAppllication' &&
                  <div className='line'>
                    <span className="cl"> <span className="token property">"applicationCategory"</span><span className="token operator">:</span> <span className="token string">"{widgetById.scmctgry}"</span><span className="token punctuation">,</span></span>
                  </div>
                }
                <div className='line'>
                  <span className="cl"> <span className="token property">"description"</span><span className="token operator">:</span> <span className="token string">"{widgetById.scmdsc}"</span><span className="token punctuation">,</span></span>
                </div>
                <div className='line'>
                  <span className="cl"> <span className="token property">"image"</span><span className="token operator">:</span> <span className="token string">["{widgetById.scmimgurl}"]</span><span className="token punctuation">,</span></span>
                </div>
                <div className='line'>
                  <span className="cl"> <span className="token property">"aggregateRating"</span><span className="token operator">:</span>
                    <span className="token punctuation">{'{'} </span>
                  </span>
                </div>
                <div className='line'>
                  <div className='line'>
                    <span className="token property">"@type"</span><span className="token operator">:</span> <span className="token string">"AggregateRating"</span><span className="token punctuation">,</span>
                  </div>
                  <div className='line'>
                    <span className="token property">"ratingValue"</span><span className="token operator">:</span> <span className="token number">{widgetValue}</span><span className="token punctuation">,</span>
                  </div>
                  <div className='line'>
                    <span className="token property">"ratingCount"</span><span className="token operator">:</span> <span className="token number">{widgetReview}</span>
                  </div>
                  <div className='line'>
                    <span className="token punctuation">{'}'} </span>
                  </div>
                </div>
                <div className='line'>
                  <span className="token punctuation">{'}'} </span>
                </div>
                <span className="token punctuation"></span>
                <span className='line'>
                  <span className="token punctuation">{'<'}</span>
                  <span className="token property">/script</span>
                  <span className="token punctuation">{'>'}</span>
                </span>
              </code>
            </pre>
          </div>

        </div>
      </div>
    </div >
  );
};

export default SchemaCard;


// WEBPACK FOOTER //
// ./src/components/Widget/SchemaCard.js